import { Session } from "@supabase/supabase-js";
import { supabase } from "../../lib/supabaseClient";

const ALLOWED_EMAIL_DOMAIN = "cifsolutions.com";

function isAllowedEmailDomain(email: string): boolean {
  return email.trim().toLowerCase().endsWith("@" + ALLOWED_EMAIL_DOMAIN);
}

export interface SignUpResult {
  error: string | null;
}

export interface SignInResult {
  error: string | null;
}

export interface SignOutResult {
  error: string | null;
}

export async function signUpWithEmailPassword(
  firstName: string,
  lastName: string,
  email: string,
  password: string
): Promise<SignUpResult> {
  if (!isAllowedEmailDomain(email)) {
    return {
      error: `Sign-up is restricted to @${ALLOWED_EMAIL_DOMAIN} email addresses.`,
    };
  }

  const { error } = await supabase.auth.signUp({
    email: email.trim(),
    password: password,
    options: {
      data: {
        first_name: firstName.trim(),
        last_name: lastName.trim(),
      },
    },
  });

  if (error) {
    return { error: error.message };
  }

  return { error: null };
}

export async function signInWithEmailPassword(
  email: string,
  password: string
): Promise<SignInResult> {
  const { error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password: password,
  });

  if (error) {
    return { error: error.message };
  }

  return { error: null };
}

export async function signOut(): Promise<SignOutResult> {
  const { error } = await supabase.auth.signOut();

  if (error) {
    return { error: error.message };
  }

  return { error: null };
}

export async function getCurrentSession(): Promise<Session | null> {
  const { data } = await supabase.auth.getSession();
  return data.session;
}
